module.exports = __webpack_public_path__ + "static/media/CTLA_9-135w.db1f20cc.webp";